import ApiService from "./api";

const AppService = {
    sendRequestForm: async function(requestForm) {
        try {
            return await ApiService.post(import.meta.env.VITE_DOMAIN + 'api/report/fromForm', requestForm);
        } catch (error) {
            ApiService.catchError(error);
        }
    },
}

export { AppService };
